<script setup>
import { usePlanningStore } from '@/stores/planning.store'
import { usePortalStore } from '@/stores/portal.store'

const props = defineProps({
  modelValue: { type: [String, null], default: null },
  contact: { type: [Number, String, null], default: null },
  referenceType: { type: Number, required: true },
})
const emit = defineEmits(['update:modelValue'])

const { referenceTypeEnum } = usePlanningStore()
const portalStore = usePortalStore()

const inputTypes = Object.freeze({ [referenceTypeEnum.PHONE]: 'tel', [referenceTypeEnum.EMAIL]: 'email' })
const referenceTypeMeta = portalStore.getLocalizedReferenceTypes().find(t => t.id === props.referenceType)
</script>

<template>
  <q-input
    :model-value="modelValue"
    :type="inputTypes[referenceType] ?? 'text'"
    :label="referenceTypeMeta.label"
    :disable="!contact"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #prepend>
      <q-icon :name="referenceTypeMeta.icon" size="xs" />
    </template>
  </q-input>
</template>
